import { Button, Label, TextArea } from "abs-ui-components";
import { MDBCol, MDBRow } from "mdbreact";
import { Controller, useFormContext } from "react-hook-form";
import { c3Fields } from "../../FeuConstants";

import "./FeuC33DistanceTravelledInIce.scss";

import { useParams } from "react-router";
import { forwardRef, useEffect, useMemo, useRef } from "react";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";

const FeuC33DistanceTravelledInIce = forwardRef(({ c33DistanceTravelledInIce, refetchMonitoringData,vesselMstId }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);
    const savedValuesRef = useRef({});
    const { dirtyFields } = formState;
    const isC33Dirty = !!(dirtyFields?.c33 && Object.keys(dirtyFields.c33).length > 0);

    useEffect(() => {
        if (c33DistanceTravelledInIce) {
            reset(prev => ({ ...prev, c33: c33DistanceTravelledInIce }));
        }
    }, [c33DistanceTravelledInIce, reset]);

    AutoSave(ref, [], async () => {
        const currentValues = getValues("c33");
        const isChanged = Object.keys(currentValues || {}).some(
            key => currentValues[key] !== savedValuesRef.current?.[key]
        );
        if (!isC33Dirty || !isChanged) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("c33");
        const payload = {
            ...c3FieldsColumns.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const c33DstTravelledInIce = await callApi({
                method: "POST",
                url: API_ROUTES.C33(vesselMstId),
                data: payload,
            });
            if (c33DstTravelledInIce?.isSuccess) {
                emitToasterMsg("success", "Table C.3.3", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c1: formValues }));
                savedValuesRef.current = { ...formValues };
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                // emitToasterMsg("success", "Table C33", "Created successfully");
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.3.3", c33DstTravelledInIce?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.3.3", error.errorMessage);
        }
    };

    const c3FieldsColumns = useMemo(() => {
        const base = c3Fields
            .filter(f => f.name !== "methodDescription")
            .map(f => ({
                ...f,
                name: f.name === "dataSources" ? "formulaeAndDataSources" : f.name,
                label: f.label === "Data sources" ? "Formulae and data sources" : f.label,
            }));

        const responsibleField = {
            label: "Name of person or position responsible for this procedure",
            name: "responsiblePersonOrPosition",
            maxLength: 1000,
        };

        const i = base.findIndex(f => f.name === "descriptionOfProcedure");

        if (i !== -1) {
            base.splice(i + 1, 0, responsibleField);
        } else {
            base.push(responsibleField);
        }

        return base;
    }, []);

    return (

        <div className="form-section mt-5">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">Determining and recording the distance travelled when sailing in ice conditions</h6>
                </MDBCol>
            </MDBRow>

            {c3FieldsColumns.map(({ label, name, maxLength }) => {
                const displayLabel =
                    label === "Description of procedures"
                        ? "Description of procedures (including recording and managing distance and winter conditions information) (a brief description of the procedure can be provided if already existing outside the monitoring plan)"
                        : label;
                return (
                    <MDBRow className="align-items-center mb-3" key={name}>
                        <MDBCol md="4">
                            <Label name={displayLabel} bold />
                        </MDBCol>
                        <MDBCol md="4">
                            <Controller
                                name={`c33.${name}`}
                                control={control}
                                render={({ field }) => (
                                    <TextArea
                                        id={`c33_${name}`}
                                        className="textarea-resize"
                                        value={field.value || ""}
                                        onChange={field.onChange}
                                        placeholder=""
                                        maxLength={maxLength}
                                        row={1}
                                    />
                                )}
                            />
                        </MDBCol>
                    </MDBRow>
                );
            })}
            <div
                className="form-row"
                style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}
            >
                <Button id="save_c33_btn"
                    disabled={!isC33Dirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                >
                    Save
                </Button>
            </div>
        </div>

    );
});

export default FeuC33DistanceTravelledInIce;
